export interface DelayCategory {
  DelayCategoryId: null | number;
  DelayCategoryName: string;
  DelayCategoryColor: string;
  AssetId: null | number;
  IsActive: boolean;
}

export const DELAY_CATEGORY_INITIAL_VALUES: DelayCategory = {
  DelayCategoryId: null,
  AssetId: null,
  DelayCategoryName: "",
  DelayCategoryColor: "",
  IsActive: true,
};
